// Imports => Utilities
import { AcGetAccessToken, AcLockObject } from '@utils';
import { ENDPOINTS } from '@constants';

// Get ENV variables
const _api_ = process.env.API_URL;
const _api_commonground_ = process.env.API_URL_COMMONGROUND;
const _wp_api_ = process.env.REACT_APP_API_URL_WP;
const _wp_api_username_ = process.env.REACT_APP_WP_API_USERNAME;
const _wp_api_password_ = process.env.REACT_APP_WP_API_PASSWORD;

const _api_commonground_organization_oin_ = process.env.API_URL_COMMONGROUND_ORGANIZATION_OIN;

// Create basic auth token if credentials are available
const _wp_api_headers_ = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

const _api_commonground_headers_ = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

const _site_ = process.env.SITE;
const _mode_ = process.env.MODE;
const _provider_ = process.env.PROVIDER;

const _auto_logout = process.env.AUTO_LOGOUT;
const _auto_logout_time = process.env.AUTO_LOGOUT_TIME;

const _register_uri_ = process.env.REGISTER_URL;

export default {
  mode: _mode_,
  autologout: {
    active: !!_auto_logout,
    time: +_auto_logout_time || 0,
  },
  rollbar: AcLockObject({
    accessToken: process.env.ROLLBAR_KEY,
    captureUncaught: true,
    captureUnhandledRejections: true,
    verbose: false,
    environment: process.env.ROLLBAR_ENVIRONMENT,
  }),
  api: {
    baseURL: `${_api_}`,
    timeout: 1000 * 60,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    credentials: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    transformRequest: [
      (data, headers) => {
        const token = AcGetAccessToken();
        if (token) headers['authorization'] = `Bearer ${token}`;
        return JSON.stringify(data);
      },
    ],
  },
  publications: {
    baseURL: `${_api_commonground_}`,
    timeout: 1000 * 60,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    credentials: false,
    headers: {
      ..._api_commonground_headers_,
    },
  },
  themes: {
    baseURL: `${_api_commonground_}`,
    timeout: 1000 * 60,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    credentials: false,
    headers: {
      ..._api_commonground_headers_,
    },
  },
  faqs: {
    baseURL: _wp_api_,
    timeout: 1000 * 60,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(_wp_api_username_ && _wp_api_password_
        ? {
            Authorization: `Basic ${btoa(`${_wp_api_username_}:${_wp_api_password_}`)}`,
          }
        : {}),
    },
  },
  pages: {
    baseURL: `${_wp_api_}`,
    timeout: 1000 * 60,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    credentials: false,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(_wp_api_username_ && _wp_api_password_
        ? {
            Authorization: `Basic ${btoa(`${_wp_api_username_}:${_wp_api_password_}`)}`,
          }
        : {}),
    },
  },
  upload: {
    baseURL: `${_api_}`,
    timeout: 1000 * 60,
    maxContentLength: 10000,
    responseType: 'json',
    responseEncoding: 'utf8',
    credentials: true,
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
      type: 'formData',
    },
    transformRequest: [
      (data, headers) => {
        const token = AcGetAccessToken();
        if (token) headers['authorization'] = `Bearer ${token}`;
        return data;
      },
    ],
  },
};
